import { useArtis } from "@artis/sdk-react";
import { useEffect } from "react";
import { setupConsole } from "./setupConsole.js";
/** Mounts `window.artis.debug.*` while alive. Render once near the root, inside an `<ArtisProvider>`. The product catalog behind `debug.find`/`debug.watch` comes from `artis.v1.products`. */
export const ApiConsole = () => {
    const artis = useArtis();
    useEffect(() => {
        if (!artis)
            return;
        return setupConsole(artis, window);
    }, [artis]);
    return null;
};
//# sourceMappingURL=ApiConsole.js.map